/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_ConvertedInputs */

const en_status_converted = /** @type {(inputs: Status_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converted`)
};

const es_status_converted = /** @type {(inputs: Status_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertido`)
};

/**
* | output |
* | --- |
* | "Converted" |
*
* @param {Status_ConvertedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_converted = /** @type {((inputs?: Status_ConvertedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_ConvertedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_converted(inputs)
	return es_status_converted(inputs)
});